var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error__wrapper",on:{"click":function (e) { return _vm.$emit('click', e); }}},[_c('error-icon',{staticClass:"error__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('layout.error-text')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }